import React, { useEffect, useState } from "react";
import "./calendarComponent.scss";

import { t } from "i18next";
import moment from "moment";
import { Stack } from "react-bootstrap";
import { useScreenSize } from "../../../../ScreenSizeContext";
import { isEmpty } from "../../../../utils/validation";

const CalendarComponent = ({ selectedDate, setSelectedDate, data }) => {
  // Nomi dei mesi in italiano
  const mesi = t("calendar.months", { returnObjects: true });
  // Giorni della settimana in italiano
  const giorniSettimana = t("calendar.abbreviated_days", {
    returnObjects: true,
  });
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    setDate(selectedDate);
  }, [selectedDate]);

  // Funzione per ottenere il numero di giorni nel mese corrente
  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  // Funzione per ottenere il primo giorno del mese corrente
  const getFirstDayOfMonth = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    return firstDay === 0 ? 6 : firstDay - 1; // Far iniziare da lunedì
  };

  // Funzione per cambiare mese
  const changeMonth = (increment) => {
    const newDate = new Date(
      date.getFullYear(),
      date.getMonth() + increment,
      1
    );
    setDate(newDate);
  };

  const isSelectedDate = (currentDateKey) => {
    if (
      selectedDate.getDate() === currentDateKey.getDate() &&
      selectedDate.getMonth() === currentDateKey.getMonth() &&
      selectedDate.getFullYear() === currentDateKey.getFullYear()
    ) {
      return true;
    } else {
      return false;
    }
  };

  const year = date.getFullYear();
  const month = date.getMonth();
  const daysInMonth = getDaysInMonth(year, month);
  const firstDayOfMonth = getFirstDayOfMonth(year, month);

  // Array dei giorni del mese corrente
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <span
          className="lnr lnr-arrow-left"
          onClick={() => changeMonth(-1)}
        ></span>
        <h2>
          {mesi[month]} {year}
        </h2>
        <span
          className="lnr lnr-arrow-right"
          onClick={() => changeMonth(1)}
        ></span>
      </div>

      <div className="calendar-grid">
        {giorniSettimana.map((giorno, index) => (
          <div key={index} className="calendar-day-name">
            {giorno}
          </div>
        ))}

        {Array.from({ length: firstDayOfMonth }).map((_, index) => (
          <div key={`empty-${index}`} className="calendar-day empty"></div>
        ))}

        {days.map((day) => {
          const currentDateKey = new Date(year, month, day);
          const dateString = moment(currentDateKey).format("DD/MM/YYYY");
          return (
            <Stack
              key={day}
              variant={"vertical"}
              onClick={() => {
                setSelectedDate(currentDateKey);
              }}
            >
              <div
                className="calendar-day"
                style={
                  isSelectedDate(currentDateKey)
                    ? {
                        backgroundColor: "#4190A3",
                        color: "white",
                      }
                    : null
                }
              >
                {day}
              </div>
              <div className="events-of-day">
                {(() => {
                  //Massimo 3 puntini per giorno
                  let count = 0;
                  return data[dateString]?.flatMap((item, index) => {
                    if (count >= 3) return [];

                    if (isEmpty(item.shifts)) {
                      count++;
                      return [
                        <EventCyrcle key={`empty-${index}`} color="#03626e" />,
                      ];
                    } else {
                      return item.shifts.slice(0, 3 - count).map((shift) => {
                        count++;
                        return (
                          <EventCyrcle key={shift.id} color={shift.color} />
                        );
                      });
                    }
                  });
                })()}
              </div>
            </Stack>
          );
        })}
      </div>
    </div>
  );
};

const EventCyrcle = ({ color }) => {
  const isPC = useScreenSize();

  return (
    <div
      style={{
        backgroundColor: color,
        borderRadius: "50%",
        width: isPC ? "10px" : "8px",
        height: isPC ? "10px" : "8px",
      }}
    ></div>
  );
};

export default CalendarComponent;
